import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { apiUrl } from "../../../../../ApiHelper/ApiUrl";
import { callApi } from "../../../../../ApiHelper/ApiHelper";
import ErrorMessage from "../../../../../components/comman/ErrorMessage";
import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../../../components/Icons/BackArrowIcon";
import MultiSelectDropdown from "../../../../../components/comman/MultiSelectDropdown";
import BgBlurLoader from "../../../../../components/Loaders/BgBlurLoader";

const EmployeeTransfer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("location?.state?.data", location?.state?.data);
  const [permissions, setPermissions] = useState("");
  const [error, setError] = useState({});
  const [error2, setError2] = useState({});
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();
  const watchType = watch("type");
  const [isTrack, setIsTrack] = useState(false);
  const [pageStates, setPageStates] = useState({
    siteList: [],
    departmentList: [],
    designationList: [],
    shiftList: [],
    officeList: [],
    customerList: [],
    companyList: [],
    selectedSites: [],
    selectedCustomer: [],
    selectedCompanies: [],
    isAssignedAllSite: location?.state?.data?.isAssignedAllSite || false,
    loadingSite: false,
    loadingDepartments: false,
    loadingDesignations: false,
    loadingCustomerCompany: false,
  });
  const [selectedSitesComputed, setSelectedSitesComputed] = useState([]);

  useEffect(() => {
    GetCompanyList();
    GetCustomerCompanyList();
    if (location?.state?.data) {
      GetDepartments(location?.state?.data?.type);
      GetShifts(location?.state?.data?.type);
      const ids = location?.state?.data?.usercompanies?.map(
        (comp) => comp.Company?.id
      );
      const preselectedCustomers =
        location?.state?.data?.usercustomers?.map((cust) => {
          return {
            id: cust?.customer?.id,
            name: cust?.customer?.name,
          };
        }) || [];
      if (location?.state?.data?.usercompanies?.length > 0) {
        const customerIds = (preselectedCustomers ?? []).map((c) => c.id);
        GetSites(
          location?.state?.data?.assignedSiteType,
          ids,
          "assignedCompanies",
          true,
          customerIds
        );
      } else {
        GetSites(
          location?.state?.data?.assignedSiteType,
          location?.state?.data?.companyId,
          "company",
          true,
          location?.state?.data?.usercustomers?.[0]?.customer?.id
        );
      }

      GetOffices();

      if (location?.state?.data?.permissions) {
        setPermissions(location?.state?.data.permissions);
      }

      const departmentId = location?.state?.data?.departmentId;
      if (departmentId) {
        GetDesignations(departmentId);
      }
      setIsTrack(true);
      setTimeout(() => {
        reset({
          userName: location?.state?.data?.name,
          companyId: location?.state?.data?.companyId,
          shiftId: location?.state?.data?.shiftId,
          designationId: location?.state?.data?.designationId,
          designationName: location?.state?.data?.designationName,
          departmentId: location?.state?.data?.departmentId,
          officeId: location?.state?.data?.officeId,
          siteType: location?.state?.data?.assignedSiteType,
          type: location?.state?.data?.type,
        });

        const preselectedCompanies = location?.state?.data?.usercompanies?.map(
          (userSite) => ({
            id: userSite?.Company?.id,
            name: userSite?.Company?.name,
          })
        );

        const preselectedSites = location?.state?.data?.usersites?.map(
          (userSite) => ({
            customerId: userSite?.site?.customerId,
            id: userSite?.site?.id,
            name: userSite?.site?.name,
          })
        );

        setPageStates((prev) => ({
          ...prev,
          selectedCompanies: preselectedCompanies || [],
          selectedCustomer: preselectedCustomers || [],
          selectedSites: preselectedSites || [],
        }));

        setLoadingData(false);
      }, 1500);
    } else {
      setLoadingData(false);
    }
  }, [location?.state?.data, reset]);

  const GetSites = (type, data, temp, reset, customerId = null) => {
    let options = {
      method: "GET",
    };
    let API = `${apiUrl?.get_site}${type === "O&M"
      ? `?type=O%26M`
      : type === "project"
        ? `?type=project`
        : "?type=site"
      }`;
    if (temp == "company") {
      API = API + `&companyId=${data}`;
    } else if (temp == "assignedCompanies") {
      API =
        API + `&companyIdArr=${data && data.join(",").replace(/['"]/g, "")}`;
    }
    if (customerId) {
      API =
        API +
        `&${location?.state?.data?.type == 1
          ? `customerIdArr=${customerId.join(",").replace(/['"]/g, "")}`
          : `customerId=${customerId}`
        }`;
    }
    setPageStates((prev) => ({
      ...prev,
      loadingSite: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        loadingSite: false,
      }));
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          siteList: response?.data?.site,
        }));
        if (reset) {
          setPageStates((prev) => ({
            ...prev,
            selectedSites: [],
          }));
        }
      }
    });
  };
  const GetOffices = () => {
    let options = {
      method: "GET",
    };
    const API = apiUrl.get_site + `?pageNumber=1&pageSize=50&type=office`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          officeList: response?.data?.site,
        }));
      }
    });
  };
  const GetCompanyList = () => {
    let options = {
      method: "GET",
    };
    const API = apiUrl.get_company + `?pageNumber=1&pageSize=50`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          companyList: response?.data?.company,
          // selectedCompanies: response?.data?.company?.filter(
          //   (item) => item?.id === firstFormData?.companyId
          // ),
        }));
      }
    });
  };
  const GetDepartments = (type) => {
    let options = {
      method: "GET",
    };
    let API = `${apiUrl?.get_department}${type == 0 ? "?type=site" : type == 1 ? "?type=office" : ""
      }`;
    setPageStates((prev) => ({
      ...prev,
      loadingDepartments: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        loadingDepartments: false,
      }));
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          departmentList: response?.data?.department,
        }));
      }
    });
  };
  const GetDesignations = (departmentId) => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_designation + `?departmentId=${departmentId}`;
    setPageStates((prev) => ({
      ...prev,
      loadingDesignations: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        loadingDesignations: false,
      }));
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          designationList: response?.data?.designation,
        }));
      }
    });
  };
  const GetShifts = (type) => {
    let options = {
      method: "GET",
    };
    let API = `${apiUrl?.get_shift}${type == 0 ? "?type=Site" : type == 1 ? "?type=Office" : ""
      }`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          shiftList: response?.data?.shift,
        }));
      }
    });
  };

  const GetCustomerCompanyList = (id = null) => {
    let options = {
      method: "GET",
    };
    const API = `${apiUrl.get_customer}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          customerList: response?.data?.customer,
        }));
      }
    });
  };

  const handleCompanyChange = (selectedOptions) => {
    setPageStates((prev) => ({
      ...prev,
      selectedCompanies: selectedOptions,
      selectedSites: [],
      siteList: [],
    }));
    const siteType = watch("siteType");
    // console.log(">>", siteType);

    if (siteType) {
      const ids = selectedOptions?.map((comp) => comp.id);
      GetSites(siteType, ids, "assignedCompanies", true);
    }
    setError2((prev) => ({ ...prev, companies: null }));
  };

  const selectedCustomerIds = useMemo(() => {
    if (watchType !== 1) return new Set();
    const selectedIds = new Set(
      (pageStates?.selectedCustomer ?? []).map((c) => c.id)
    );
    return selectedIds;
  }, [watchType, pageStates?.selectedCustomer]);

  const siteOptions = useMemo(() => {
    if (watchType !== 1) return [];
    return (pageStates?.siteList ?? []).filter((s) =>
      selectedCustomerIds.has(s.customerId)
    );
  }, [watchType, pageStates?.siteList, selectedCustomerIds]);

  const removedSiteIds = useMemo(() => {
    if (watchType !== 1 || isTrack) return new Set();
    return new Set((pageStates?.removeSitesList ?? []).map((s) => s.id));
  }, [watchType, pageStates?.removeSitesList]);

  useEffect(() => {
    if (watchType === 1 && isTrack == false) {
      setSelectedSitesComputed(
        siteOptions.filter((s) => !removedSiteIds.has(s.id))
      );
      setIsTrack(false);
    }
  }, [watchType, siteOptions, removedSiteIds]);

  const handleChangeCustomerCompany = (selectOptions) => {
    setIsTrack(false);
    const siteType = watch("siteType");
    if (watchType == 0) {
      const companyId = watch("companyId");
      setPageStates((prev) => ({
        ...prev,
        selectedCustomer: selectOptions ?? [],
      }));
      GetSites(siteType, companyId, "company", true, selectOptions?.[0]?.id);
    } else {
      const prevIds = new Set(
        (pageStates?.selectedCustomer ?? []).map((c) => c.id)
      );
      const nextIds = new Set((selectOptions ?? []).map((c) => c.id));

      const removedCustomerIds = [...prevIds].filter((id) => !nextIds.has(id));

      const addedCustomerIds = [...nextIds].filter((id) => !prevIds.has(id));

      let prunedRemoveSitesList = (pageStates?.removeSitesList ?? []).filter(
        (s) => !removedCustomerIds.includes(s.customerId)
      );

      if (addedCustomerIds.length > 0) {
        prunedRemoveSitesList = prunedRemoveSitesList.filter(
          (s) => !addedCustomerIds.includes(s.customerId)
        );
      }
      setPageStates((prev) => ({
        ...prev,
        selectedCustomer: selectOptions ?? [],
        removeSitesList: prunedRemoveSitesList,
      }));
      const assignedCompanyIds =
        pageStates?.selectedCompanies?.map((c) => c.id) ?? [];
      const customerIds = (selectOptions ?? []).map((c) => c.id);
      GetSites(
        siteType,
        assignedCompanyIds,
        "assignedCompanies",
        false,
        customerIds
      );
    }

    setError((prev) => ({ ...prev, customer: null }));
  };

  const handleSiteChange = (selectedOptions) => {
    if (watchType === 1) {
      const selectedIds = new Set((selectedOptions ?? []).map((s) => s.id));

      const prevSelectedIds = new Set(selectedSitesComputed.map((s) => s.id));

      const newlyDeselected = selectedSitesComputed.filter(
        (s) => !selectedIds.has(s.id)
      );

      const reselectedIds = (selectedOptions ?? [])
        .map((s) => s.id)
        .filter((id) =>
          (pageStates?.removeSitesList ?? []).some((r) => r.id === id)
        );

      const updatedRemoveList = (pageStates?.removeSitesList ?? [])
        .filter((r) => !reselectedIds.includes(r.id))
        .concat(newlyDeselected);

      const stillSelectedCustomerIds = new Set(
        (selectedOptions ?? []).map((s) => s.customerId)
      );
      const updatedSelectedCustomers = (
        pageStates?.selectedCustomer ?? []
      ).filter((c) => stillSelectedCustomerIds.has(c.id));

      setPageStates((prev) => ({
        ...prev,
        removeSitesList: updatedRemoveList,
        selectedCustomer: updatedSelectedCustomers,
      }));
    } else {
      setPageStates((prev) => ({
        ...prev,
        selectedSites: selectedOptions,
      }));
    }
    setError((prev) => ({ ...prev, sites: null }));
  };

  useEffect(() => {
    if (watchType == 1) {
      const prev = pageStates?.selectedSites ?? [];
      const next = selectedSitesComputed;

      const same =
        prev.length === next.length &&
        prev.every((p) => next.some((n) => n.id === p.id));

      if (!same) {
        setPageStates((prevState) => ({ ...prevState, selectedSites: next }));
      }
    }
  }, [selectedSitesComputed]);

  const onSubmit = (data) => {
    if (location?.state?.data?.usersites?.[0]?.site?.id === pageStates?.selectedSites?.[0]?.id) {
      return toast.error("Change site before submit to transfer employee.");
    }
    const submitData = {
      userId: location?.state?.data?.id,
      assignedSiteType: data?.siteType,
      siteId: pageStates?.selectedSites?.[0]?.id,
      fromSiteId: location?.state?.data?.usersites?.[0]?.site?.id,
      customerId: pageStates?.selectedCustomer?.[0]?.id,
      departmentId: data?.departmentId,
      designationId: data?.designationId,
      shiftId: data?.shiftId,
      designationName: data?.designationName,
    };

    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.transfer_employee;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        navigate(-2);
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <>
      {loadingData && <BgBlurLoader />}
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-start justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button className="btn back-arrow" onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">Employee Transfer</h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="name" className="form-label">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  maxLength={160}
                  {...register("userName", {
                    // required: "Please enter designation name",
                  })}
                  disabled
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  OnRoll Company
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  {...register("companyId", {
                    // required: "Please select Company",
                    onChange: (e) => {
                      setValue("type", "");
                      setValue("officeId", "");
                      setValue("siteType", "");
                      setPageStates((prev) => ({
                        ...prev,
                        selectedCompanies: [],
                      }));
                      setPageStates((prev) => ({
                        ...prev,
                        selectedSites: [],
                      }));
                      setValue("departmentId", "");
                      setValue("designationId", "");
                      setValue("shiftId", "");
                      setValue("company", location?.state?.data?.companyId);
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        GetDepartments(selectedValue);
                        GetShifts(selectedValue);
                      }
                      if (selectedValue == 1) {
                        GetOffices();
                      }
                    },
                  })}
                  disabled
                >
                  <option value="" className="d-none">
                    Select Company
                  </option>
                  {pageStates?.companyList?.length > 0 ? (
                    pageStates?.companyList?.map((item, index) => {
                      return (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })
                  ) : (
                    <option disabled value="">
                      No data found
                    </option>
                  )}
                </select>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Employee Type
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  {...register("type", {
                    // required: "Please select Employee Type",
                    onChange: (e) => {
                      GetCompanyList();
                      setValue("officeId", "");
                      setValue("siteType", "");
                      setPageStates((prev) => ({
                        ...prev,
                        selectedCompanies: [],
                      }));
                      setPageStates((prev) => ({
                        ...prev,
                        selectedSites: [],
                        siteList: [],
                      }));
                      setValue("departmentId", "");
                      setValue("designationId", "");
                      setValue("shiftId", "");
                      setValue("company", location?.state?.data?.companyId);
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        GetDepartments(selectedValue);
                        GetShifts(selectedValue);
                      }
                      if (selectedValue == 1) {
                        GetOffices();
                      }
                    },
                  })}
                  disabled
                >
                  <option value="" className="d-none">
                    Select Employee Type
                  </option>
                  <option value={0}>Site Staff</option>
                  <option value={1}>Office Staff</option>
                </select>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Site Type
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  {...register("siteType", {
                    required: "Please select Site Type",
                    onChange: (e) => {
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        if (watchType == 1) {
                          if (pageStates?.selectedCompanies?.length === 0) {
                            toast.info("Please Select company");
                            return;
                          }
                        }
                        if (watchType == 0) {
                          const companyId = getValues("companyId");
                          GetSites(selectedValue, companyId, "company", true);
                        } else if (watchType == 1) {
                          const companyIds = pageStates?.selectedCompanies?.map(
                            (comp) => comp.id
                          );
                          GetSites(
                            selectedValue,
                            companyIds,
                            "assignedCompanies",
                            true
                          );
                        }
                        setPageStates((prev) => ({
                          ...prev,
                          selectedSites: [],
                        }));
                      }
                    },
                  })}
                >
                  <option value="" className="d-none">
                    Select Site Type
                  </option>
                  <option value={"O&M"}>O&amp;M</option>
                  <option value={"project"}>Project</option>
                  {Number(watchType) === 1 && (
                    <option value={"both"}>Both</option>
                  )}
                </select>
                <ErrorMessage message={errors?.siteType?.message} />
              </div>
            </div>

            {watchType == 1 && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="form-group mb-3">
                  <label htmlFor="Role" className="form-label">
                    Assign Company
                    <span className="text-danger">*</span>
                  </label>
                  <MultiSelectDropdown
                    options={pageStates?.companyList || []}
                    selectedValues={pageStates?.selectedCompanies}
                    onChange={handleCompanyChange}
                    multiSelect={watchType == 1 ? true : false}
                    setPageStates={setPageStates}
                  />
                  {error2.companies && (
                    <ErrorMessage message={error2.companies} />
                  )}
                </div>
              </div>
            )}

            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Customer
                  <span className="text-danger">*</span>
                </label>
                <MultiSelectDropdown
                  options={pageStates?.customerList || []}
                  selectedValues={pageStates?.selectedCustomer}
                  onChange={handleChangeCustomerCompany}
                  multiSelect={watchType == 1 ? true : false}
                  setPageStates={setPageStates}
                  isLoading={pageStates.loadingCustomerCompany}
                />
                {error.customer && <ErrorMessage message={error.customer} />}
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Site
                  <span className="text-danger">*</span>
                </label>
                <MultiSelectDropdown
                  options={pageStates?.siteList || []}
                  selectedValues={pageStates?.selectedSites}
                  onChange={handleSiteChange}
                  multiSelect={watchType == 1 ? true : false}
                  setPageStates={setPageStates}
                  isLoading={pageStates.loadingSite}
                />
                {error.sites && <ErrorMessage message={error.sites} />}
              </div>
            </div>

            {watchType == 1 && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="form-group mb-3">
                  <label htmlFor="Role" className="form-label">
                    Office
                    <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select form-control"
                    aria-label="Default select example"
                    {...register("officeId", {
                      required: watchType == 1 ? "Please select Office" : false,
                    })}
                  >
                    <option value="" className="d-none">
                      Select Office
                    </option>
                    {pageStates?.officeList?.length > 0 &&
                      pageStates?.officeList?.map((item, index) => {
                        return (
                          <option key={index} value={item?.id}>
                            {item?.name}
                          </option>
                        );
                      })}
                  </select>
                  <ErrorMessage message={errors?.officeId?.message} />
                </div>
              </div>
            )}

            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Department
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  disabled={pageStates?.loadingDepartments}
                  {...register("departmentId", {
                    required: "Please select Department",
                    onChange: (e) => {
                      setValue("designationId", "");
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        GetDesignations(selectedValue);
                      }
                    },
                  })}
                >
                  {pageStates?.loadingDepartments ? (
                    <option value="">
                      Loading...{" "}
                      <span className="spinner-border spinner-border-sm"></span>
                    </option>
                  ) : (
                    <>
                      <option value="" className="d-none">
                        Select Department
                      </option>
                      {pageStates?.departmentList?.map((item, index) => (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </>
                  )}
                </select>
                <ErrorMessage message={errors?.departmentId?.message} />
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  System Permission
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  disabled={pageStates?.loadingDesignations} // Disable dropdown if loading
                  {...register("designationId", {
                    required: "Please select System Permission",
                  })}
                >
                  {pageStates?.loadingDesignations ? (
                    <option value="">
                      Loading...{" "}
                      <span className="spinner-border spinner-border-sm"></span>
                    </option>
                  ) : (
                    <>
                      <option value="" className="d-none">
                        Select Designation
                      </option>
                      {pageStates?.designationList?.map((item, index) => (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </>
                  )}
                </select>
                <ErrorMessage message={errors?.designationId?.message} />
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Shift
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  {...register("shiftId", {
                    required: "Please select Shift",
                  })}
                >
                  <option value="" className="d-none">
                    Select Shift
                  </option>
                  {pageStates?.shiftList?.length > 0 &&
                    pageStates?.shiftList?.map((item, index) => {
                      return (
                        <option key={index} value={item?.id}>
                          {item?.shiftName}
                        </option>
                      );
                    })}
                </select>
                <ErrorMessage message={errors?.shiftId?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="firstName" className="form-label">
                  Designation Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Designation Name"
                  id="firstName"
                  maxLength={160}
                  aria-describedby="emailHelp"
                  {...register("designationName", {
                    required: "Please enter designation name",
                  })}
                />
                <ErrorMessage message={errors?.designationName?.message} />
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-3">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading ? <Spinner /> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default EmployeeTransfer;
